/* eslint-disable */
import React from 'react';
import {Link} from 'gatsby';
import useSiteMeta from '../../query/useSiteMeta';
import useMenu from '../../query/useMenu';
import Phone from '../Phone';
import Button from '../Button';

import styles from './styles.module.css';

const Footer = () => {
  const {footerMenu} = useMenu();
  const {name, phone, address} = useSiteMeta();
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <div className={styles.footer__infos}>
          <div className={styles.footer__logo}>
            <span>{name}</span>
          </div>
          <div className={styles.footer__adresse}>
            {address}
            {phone && (
              <>
                <br />
                <Phone>{phone}</Phone>
              </>
            )}
          </div>
        </div>
        <div className={styles.footer__nav}>
          <ul>
            {footerMenu.nodes.map(({navigation}) =>
              navigation.map(({page, label}) => (
                <li key={page.id}>
                  <Link to={page.fields.slug}>
                    {label || page.frontmatter.title}
                  </Link>
                </li>
              )),
            )}
            <li>
              <Button
                mode="link"
                onClick={e => {
                  e.preventDefault();
                  window._gdpr_showModal();
                }}
              >
                Préférences des cookies
              </Button>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.goodmotion}>
        Made with&#160;
        <span role="img" aria-label="love">
          💖
        </span>
        &#160;by&#160;
        {/** eslint-disable-next-line */}
        <a
          href="https://www.goodmotion.fr/"
          target="_blank"
          title="creation de site web"
        >
          Goodmotion
        </a>
      </div>
    </footer>
  );
};

export default Footer;
